import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data,
    legacySilentError: true
  })
}

export function fetchCurrentUser() {
  return request({
    url: '/users/me',
    method: 'get'
  })
}

export function logout() {
  return request({ successMessage: '已退出登录',
    url: '/auth/logout',
    method: 'post'
  })
}
